import { render } from "./editScoringModal.vue?vue&type=template&id=f6f832c0&scoped=true&ts=true"
import script from "./editScoringModal.vue?vue&type=script&lang=ts"
export * from "./editScoringModal.vue?vue&type=script&lang=ts"

import "./editScoringModal.vue?vue&type=style&index=0&id=f6f832c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f832c0"]])

export default __exports__